import { createReducer } from '../../utils/';
import { combineReducers } from 'redux';
import constant from './constant';

const IndexListhandlers = {
    [constant.INDEXLIST](state, action) {
        return action.payload;
    },
};

const stateHandlers = {
    [constant.ListLoading](state, action) {
        return { ...state, loading: action.payload };
    },
};

const taskTodyHandlers = {
    [constant.TODYTASK](state, action) {
        return action.payload;
    },

};
const taskTodyResulttHandlers = {
    [constant.TASKINDEXLIST](state, action) {
        return action.payload;
    },
}


const nomalAgentConnInfoHandlers = {
    [constant.NOMALAGENTCONNINFO](state, action) {
        return action.payload;
    },
};

const phoneAgentConnInfoHandlers = {
    [constant.PHONEAGENTCONNINFO](state, action) {
        return action.payload;
    },
};

const agentMonitorHandlers = {
    [constant.AGENT](state, action) {
        return action.payload;
    },

};

const taskLoadingHandlers = {
    [constant.TASKLOADING](state, action) {
        return { ...state, ...action.payload };
    },
};

const taskMonitorHandlers = {
    [constant.TASK](state, action) {
        return action.payload;
    },

};

const serviceMonitorHandlers = {
    [constant.SERVICE](state, action) {
        return action.payload;
    },
};

const discardMonitorHandlers = {
    [constant.DISCARD](state, action) {
        return { ...state, ...action.payload };
    },
};

export const ListStatus = createReducer({ loading: false }, stateHandlers); // 列表状态
export const IndexList = createReducer([], IndexListhandlers); // 列表
export const TodyTask = createReducer({}, taskTodyHandlers); // 今日任务
export const todayTaskResult = createReducer({}, taskTodyResulttHandlers); // 今日任务执行结果
export const PhoneAgentConnInfo = createReducer([], phoneAgentConnInfoHandlers); // 连接数统计
export const NomalAgentConnInfo = createReducer([], nomalAgentConnInfoHandlers); // 连接数统计
export const AgentMinotor = createReducer([], agentMonitorHandlers); // 代理
export const TaskStatus = createReducer({ loading: false }, taskLoadingHandlers);
export const TaskMinotor = createReducer([], taskMonitorHandlers); // 实时任务
export const ServiceMinotor = createReducer({}, serviceMonitorHandlers); // 服务任务
export const discardMinotor = createReducer({discardList: [], threadList: [], isLoading: false}, discardMonitorHandlers); // 服务任务

export const index = combineReducers({
    IndexList,
    ListStatus,
    TodyTask,
    PhoneAgentConnInfo,
    NomalAgentConnInfo,
    AgentMinotor,
    TaskStatus,
    TaskMinotor,
    ServiceMinotor,
    discardMinotor,
    todayTaskResult,
});



// WEBPACK FOOTER //
// ./pages/index/reducers.js